import { render, staticRenderFns } from "./Investments.vue?vue&type=template&id=225c52f8&scoped=true&"
import script from "./Investments.vue?vue&type=script&lang=js&"
export * from "./Investments.vue?vue&type=script&lang=js&"
import style0 from "./Investments.vue?vue&type=style&index=0&id=225c52f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225c52f8",
  null
  
)

export default component.exports